import React, { Component } from "react";
import styled from "styled-components";
import { scrollIntoView, } from "./utils";
import { Icon } from "../../icons/icon";
import tinycolor from "tinycolor2";
import { StyleScrollBarHidden } from "../../styles/style-scrollbar-hidden";
/**
 * 滚动选择框
 *
 * 受控组件
 *
 * @author 张卓诚
 * @export
 * @class ScrollSelector
 * @extends {Component<ScrollSelectorProps>}
 * @implements {Color}
 * @implements {ICSS}
 */
export class ScrollSelector extends Component {
    constructor(props) {
        super(props);
        /** 样式 */
        // tslint:disable: variable-name
        // tslint:disable-next-line: naming-convention
        this.Root = styled.div `
    width: 100%;
    height: 100%;
    color: inherit;
    cursor: pointer;
    position: relative;
    .scroll{
      height: 100%;
      width: 100%;
      pointer-events: none;
      overflow-y: scroll;
      mask-image: linear-gradient(to bottom,
        rgba(216, 216, 216, 0.05) 0%,
        rgba(216, 216, 216, 0.25) 25%,
        rgba(216, 216, 216, 1) 45%,
        rgba(216, 216, 216, 1) 55%,
        rgba(216, 216, 216, 0.25) 75%,
        rgba(216, 216, 216, 0.05) 100%
      );
      > * {
        height: 26px;
        line-height: 26px;
        width: 100%;
        font-size: 16px;
        font-weight: 500;
        text-align: center;
        &:hover{
          color: ${this.props.colorPalette.mainColor[1]};
        }
      }
      > *.selected {
        color: ${this.props.colorPalette.mainColor[1]};
        &:hover{
          color: ${this.props.colorPalette.mainColor[1]};
        }
      }
    }
    .control{
      height: 100%;
      top: 0;
      position: absolute;
      width: 100%;
      .line-up,.line-down{
        position: absolute;
        width: 100%;
        height: 1px;
        opacity: 0.45;
        border-style: solid;
        border-width: 1px;
        border-image-source:
          radial-gradient(circle at 50% 50%, #ffffff, ${tinycolor(this.props.colorPalette.mainColor[2]).setAlpha(0).toRgbString()});
        border-image-slice: 1;
      }
      &:hover{
        .line-up,.line-down{
          opacity: 0.85;
        }
        .icon-up,.icon-down{
          opacity: 1;
        }
      }
      .line-up{
        top: 17px;
      }
      .line-down{
        bottom: 17px;
      }
      .icon-up,.icon-down{
        position: absolute;
        opacity: 0;
        width: 100%;
        height: 14px;
        line-height: 14px;
        font-size: 12px;
        text-align: center;
        &:hover{
          color: ${this.props.colorPalette.mainColor[1]};
        }
        user-select: none;
      }
      .icon-up{
        top: 0;
      }
      .icon-down{
        bottom: 0;
      }

    }

  `;
        /**
         * 下一项
         *
         * @memberof ScrollSelector
         */
        this.next = () => {
            const index = this.props.datas.map(item => item.key).indexOf(this.props.selected);
            if (index < this.props.datas.length - 1) {
                this.props.onChange(this.props.datas[index + 1].key);
            }
        };
        /**
         * 上一项
         *
         * @memberof ScrollSelector
         */
        this.pre = () => {
            const index = this.props.datas.map(item => item.key).indexOf(this.props.selected);
            if (index > 0) {
                this.props.onChange(this.props.datas[index - 1].key);
            }
        };
    }
    componentDidMount() {
        scrollIntoView(`.drop-down-interaction .key-${this.props.selected}`);
    }
    componentDidUpdate() {
        scrollIntoView(`.drop-down-interaction .key-${this.props.selected}`);
    }
    shouldComponentUpdate(nextProps) {
        return JSON.stringify(this.props) !== JSON.stringify(nextProps);
    }
    render() {
        return (React.createElement(this.Root, { className: `drop-down-interaction ${this.props.className}`, style: this.props.style },
            React.createElement(StyleScrollBarHidden, { className: "scroll" },
                React.createElement("div", null),
                React.createElement("div", null),
                // tslint:disable-next-line: jsx-no-multiline-js
                this.props.datas.map((data) => (React.createElement("div", { key: data.key, className: `key-${data.key}${this.props.selected === data.key ? " selected" : ""}` }, data.name))),
                React.createElement("div", null),
                React.createElement("div", null)),
            React.createElement("div", { className: "control" },
                React.createElement("div", { className: "icon-up", onClick: this.pre },
                    React.createElement(Icon, null, "up")),
                React.createElement("div", { className: "line-up" }),
                React.createElement("div", { className: "line-down" }),
                React.createElement("div", { className: "icon-down", onClick: this.next },
                    React.createElement(Icon, null, "down")))));
    }
}
//# sourceMappingURL=scroll-selector.js.map